import { JSX, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";

import { asTitle } from "utils/Utils";

import { getExtractRights } from "./ExtractService";

interface ExtractAccessDialogProps {
	id: number;
	onClose: () => void;
}

export default function ExtractAccessDialog(
	props: Readonly<ExtractAccessDialogProps>
): JSX.Element {
	const [t] = useTranslation();

	const [rights, setRights] = useState<string[]>([]);

	useEffect(() => {
		getExtractRights(props.id).then(setRights);
	}, []);

	return (
		<Dialog open fullWidth maxWidth="xs" onClose={props.onClose}>
			<DialogTitle id="dialog-title">
				{asTitle(t("extractShared"))}
			</DialogTitle>
			<DialogContent>
				<Grid container direction="column" spacing={2}>
					{rights.map(user => (
						<Grid item key={user}>
							{user}
						</Grid>
					))}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose} autoFocus>
					 {t("close")}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
